import { api, getApiState } from "./api";
import { getQueryStringState } from "./queryString";
import { PROGRESS } from "./asyncHttpAction";
import { DASHBOARD_CONFIG_DICT } from "./wevos/constants";
import { createSelector } from "reselect";
import { denormalize } from "normalizr";
import { wevoSchema } from "../schemas";
import { DashboardEvents } from "./tracker/event-names";
import * as queryString from "query-string";
import { trackEvent } from "./tracker/actions";
import * as router from "react-router-redux";
import { notifyInfo, notifyError } from "./notifications/actions";
import { FaArchive, FaInbox, FaTrash } from "react-icons/fa";

export function deleteWevo(wevo) {
    return async dispatch => {
        const result = await dispatch(api.wevos.delete(wevo.id));
        if (!result.error) {
            dispatch(notifyError(`Deleted "${wevo.name}"`, FaTrash));
        }
    };
}

export function archiveWevo(wevo) {
    return async dispatch => {
        const result = await dispatch(api.wevos.updateArchived(wevo.id, true));
        if (!result.error) {
            dispatch(notifyInfo(`Archived "${wevo.name}"`, FaArchive));
        }
    };
}

export function unarchiveWevo(wevo) {
    return async dispatch => {
        const result = await dispatch(api.wevos.updateArchived(wevo.id, false));
        if (!result.error) {
            dispatch(notifyInfo(`Unarchived "${wevo.name}"`, FaInbox));
        }
    };
}

export function editTest(wevo) {
    return async (dispatch, getState) => {
        dispatch(
            trackEvent(DashboardEvents.DID_CLICK_EDIT_TEST, {
                wevoId: wevo.id,
                teamId: wevo.ownerTeamId
            })
        );
        return dispatch(
            router.push(`/team/${wevo.ownerTeamId}/edit/${wevo.id}`)
        );
    };
}

export function viewTestResults(wevo) {
    return async (dispatch, getState) => {
        dispatch(
            trackEvent(DashboardEvents.DID_CLICK_VIEW_RESULTS, {
                wevoId: wevo.id,
                teamId: wevo.ownerTeamId
            })
        );
        return dispatch(
            router.push(`/team/${wevo.ownerTeamId}/results/${wevo.id}`)
        );
    };
}

export function viewTestDetails(wevo) {
    return async (dispatch, getState) => {
        dispatch(
            trackEvent(DashboardEvents.DID_CLICK_VIEW_DETAILS, {
                wevoId: wevo.id,
                teamId: wevo.ownerTeamId
            })
        );
        return dispatch(
            router.push(`/team/${wevo.ownerTeamId}/details/${wevo.id}`)
        );
    };
}

export function selectStatus(status) {
    return async (dispatch, getState) => {
        dispatch(
            trackEvent(DashboardEvents.DID_CHANGE_TABS, {
                from_tab: getSelectedStatus(getState()),
                to_tab: status
            })
        );

        const queryParams = {
            ...getState().queryString,
            status
        };

        return dispatch(
            router.replace({
                search: queryString.stringify(queryParams)
            })
        );
    };
}

export function getTeamIdProp(state, props) {
    return parseInt(props.match.params.teamId, 10);
}

export function getDashboardState(state) {
    return state.dashboard;
}

export const getSelectedStatus = createSelector(
    [getApiState, getQueryStringState],
    (api, queryString) => {
        return queryString.status || "all";
    }
);

export const getFilteredWevos = createSelector(
    [getApiState, getDashboardState, getSelectedStatus],
    (api, dashboard, status) => {
        const statusConfig =
            DASHBOARD_CONFIG_DICT[status] || DASHBOARD_CONFIG_DICT["all"];
        const wevos = denormalize(dashboard.wevoIds, [wevoSchema], api) || [];
        return wevos.filter(
            wevo => statusConfig.wevoFilter(wevo) && !wevo.isDeleted
        );
    }
);

const INITIAL_STATE = {
    wevoIds: [],
    listWevosRequest: PROGRESS.initial
};

export function reducer(state = INITIAL_STATE, action) {
    let data;
    switch (action.type) {
        case api.teams.wevos.list.REQUEST:
            return {
                ...state,
                wevoIds: [],
                listWevosRequest: PROGRESS.loading
            };

        case api.teams.wevos.list.SUCCESS:
            data = action.payload.data;
            return {
                ...state,
                wevoIds: [...data.result],
                listWevosRequest: PROGRESS.success
            };

        case api.teams.wevos.list.ERROR:
            return {
                ...state,
                wevoIds: [],
                listWevosRequest: PROGRESS.error
            };

        case api.wevos.delete.SUCCESS:
            data = action.payload.data;
            return {
                ...state,
                wevoIds: state.wevoIds.filter(id => id !== data.result)
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard.js